(function () {

  'use strict';

  angular.module('WorkflowProperties')
    .controller('WorkflowPropertiesController', function (
      $scope, EventHandlerService, currentTenant, WorkflowService,
      $routeParams, URL_PARAMS, $rootScope, EventServiceEvents) {

      $scope.tenant = currentTenant;
      $scope.workflow = null;
      $scope.me = null;

      $scope.helpCaption = 'HelpCaptureWorkflows';

      (function () {
        initEventHandler();
        setListeners();
        getWorkflow();
      })();

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      function getWorkflow() {
        WorkflowService.getWorkflowById($routeParams[URL_PARAMS.WORKFLOW_ID.ROUTE])
          .then(function (workflow) {
            $scope.workflow = workflow;
          })
          .catch(function () {
          });
      }

      function initEventHandler() {
        EventHandlerService.deRegisterListeners();
      };

      function updateWorkflow() {
        WorkflowService.getWorkflowById($routeParams[URL_PARAMS.WORKFLOW_ID.ROUTE])
          .then(function (workflow) {
            $rootScope.$broadcast(`WORKFLOW_UPDATED_${$routeParams[URL_PARAMS.WORKFLOW_ID.ROUTE]}`, { workflow: workflow });
          })
          .catch(function () {
          });
      }

      function setListeners() {
        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKFLOW_UPDATED, function (name, data) {
          const workflow = data.workflow.split('/').pop();
          if (workflow === $routeParams[URL_PARAMS.WORKFLOW_ID.ROUTE]) {
            updateWorkflow();
          }
        });
      }

      $scope.$on('REQUEST_ERROR_HELP', (name, data) => {
        $scope.error = data.error;
      });

      $scope.clearError = () => {
        $scope.error = null;
      };

    });
})();
